import React from 'react';

import { Text, Paragraph } from 'components/core/Typography';


import './ScarcityBanner.scss';

export default function ScarcityBanner() {
	return (
		<div className="scarcity-banner">
			<div className="banner-content">
				<Text size="medium" color="white">Reserve Now!</Text>
				{' '}
				<Paragraph color="white" className="scarcity-text" last>
					Pricing and availability may change.
				</Paragraph>
			</div>
		</div>
	);
}
